import Channel from './Channel.container';

export default Channel;



// WEBPACK FOOTER //
// ./src/ui/channels/children/channel/index.js